import { useEffect, useRef } from 'react';

/**
 * Invoke `handler` synchronously on the window 'beforeunload' event. The latest
 * handler is always used (no stale closure) and the listener is attached once
 * for the lifetime of the consuming component.
 */
export const useBeforeUnload = (handler: () => void): void => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const onBeforeUnload = () => handlerRef.current();
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);
};
